import { isEmpty } from 'lodash';
import { useQuery } from '../useQuery';
import { getRescheduleReasons } from '@dispatch/shared/services';

export const useGetRescheduleReasons = (
  { tenantId }: { tenantId: string },
  enabled = true
) => {
  const { data, refetch, status } = useQuery(
    ['reschedule-reasons', tenantId],
    () => getRescheduleReasons(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    rescheduleReasons: data,
    fetchRescheduleReasons: refetch,
    rescheduleReasonStatus: status,
  };
};
